import embeddedAppUtils from 'utils/embeddedAppUtils';
import storageService, { Locals } from 'utils/storageService';

/**
 * Resolves the auth token used for SSE connections, mirroring the
 * embedded-vs-standalone branch in `utils/axios.ts` `headers()`.
 *
 * - Embedded: a fresh Shopify session token (`shopify.idToken()`), short-lived (~60s).
 * - Standalone: the access token persisted in localStorage.
 *
 * Called on every (re)connect attempt so reconnects always carry a fresh token.
 */
export const getSseAuthToken = async (): Promise<string | undefined> => {
    if (embeddedAppUtils.isAppEmbedded()) {
        return shopify.idToken();
    }
    return storageService.getObject(Locals.ACCESS_TOKEN) || undefined;
};
